<template>
<div class="main">
    <Table
        :columns="columns"
        row-key="id"
        :request="request"
        :searchData ="searchData"
        :params="{status:'1'}"
        :formData="formData"
		ref="tableref"
    >
        <template v-slot:formItem>
           <a-form-model-item >
               <a-input v-model="searchData.name" allowClear  placeholder="请输入合同名称"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-select style="width:150px" placeholder="请选择合同类型" allowClear v-model ="searchData.type" >
					<a-select-option  v-for="item in contractTypes"  :value="item.value" :key="item.value" >{{ item.title }}</a-select-option>
               </a-select>
           </a-form-model-item> 
        </template>
        <template v-slot:tableAction="{record,showModal,showDelConfirm}">
           <a class="tAction" @click="viewcon(record)"><a-icon type="snippets" /> 查 看</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="deletecon(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="showauth(record)"> 权限分配 </a>
        </template>
        <template v-slot:meiju="{text}">
            {{contractTypes[text-1].title}}
        </template>
    </Table>
	<Auth ref="auth" ></Auth>
</div>
</template>

<script>
import Table from "@/components/AdvanceTable"
import {getSearchParm} from "@/utils/index.js"
import {getContractList,deleteContract} from "@/api/contract.js"
import Auth from './auth/auth.vue'
import {contractTypes} from '@/components/commendata'
const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"name",key:"name",title:"合同名称"},
    {dataIndex:"type",key:"type",title:"合同类型",scopedSlots:{customRender:"enum"}},
    {key:"action",title:"操作",align:"center",scopedSlots: { customRender: 'action' }},
]
export default {
    data(){
        let {type,name} = this.$route.query
        return{
            columns,
            request:{
                "get":getContractList,
                "delet":deleteContract
            },
            searchData:getSearchParm({
                name:name||"",
                type:type||""
            }),
            formData:{
            },
			contractTypes,
        }
    },
    components:{
        Table,
		Auth
    },
    methods:{
        deletecon(record,showDelConfirm){
            this.formData = record
            showDelConfirm()
        },
        viewcon(record){
            this.$router.push({name:"contractdetial",params:{id:record.id},query:this.searchData})
        },
		showauth(record){
			this.$refs.auth.showAuth(record,this.$refs.tableref.getSearchData)
		}
    }
    
}
</script>

<style lang="less" scoped>
.main{
    .tAction{
        display: inline-block;
        padding: 0px 10px;
    }
}
</style>


